import React from 'react';
import { motion } from 'framer-motion';
export function CreatorQuote() {
  return <section className="py-10 sm:py-12 px-4 bg-brand-dark border-y border-white/5" data-id="element-74">
      <div className="max-w-3xl mx-auto text-center" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-76">
          <h3 className="text-xs font-black text-brand-orange uppercase mb-6 tracking-widest" data-id="element-77">
            A proposito di KITONLINE™
          </h3>

          <blockquote className="text-lg sm:text-xl md:text-2xl font-medium text-brand-cream italic leading-relaxed" data-id="element-78">
            "Abbiamo creato questo sistema per liberare ossigeno ai docenti di
            Lettere, togliendo il peso soffocante della preparazione manuale.
            Più tempo per insegnare, meno tempo per pianificare."
          </blockquote>
        </motion.div>
      </div>
    </section>;
}